import { observer } from 'src/utils/mobx-react';
import CheckboxMultiSelect from 'src/components/CheckboxMultiSelect/CheckboxMultiSelect.jsx';
import React from 'react';
import { Checkbox, Input } from 'src/components/MarketTemplateSettingsForm/FormComponents/MarketTemplateInputs';
import { MarketTemplateSettingsFormState } from 'src/components/MarketTemplateSettingsForm/MarketTemplateSettingsForm.state';

type MarketTemplateSettingsPropsType = {
    marketTemplateSettingsState: MarketTemplateSettingsFormState;
}
export const MarketTemplateSettings = observer('MarketTemplateSettings', (props: MarketTemplateSettingsPropsType) => {
    const {marketTemplateSettingsState} = props;

    const currentTemplate = marketTemplateSettingsState.currentTemplate;
    if (currentTemplate === null) {
        return null;
    }
    return (
        <div className='col-4'>
            <h4>Settings</h4>
            <Input
                dataTest='name'
                label='Name'
                name='marketName'
                value={currentTemplate.marketName}
                onSave={marketTemplateSettingsState.onSaveTemplate}
            />
            {
                currentTemplate.marketSubtype === undefined || currentTemplate.marketSubtype === null ? null :
                    <Input
                        dataTest='display-name'
                        label='Display name'
                        name='displayName'
                        value={currentTemplate.displayName ?? undefined}
                        onSave={marketTemplateSettingsState.onSaveTemplate}
                    />
            }
            <Input
                dataTest='in-play-bet-delay'
                label='In play bet delay'
                name='inPlayDelay'
                value={currentTemplate.inPlayDelay ?? undefined}
                onSave={marketTemplateSettingsState.onSaveTemplate}
            />

            <Checkbox
                dataTest='bet-referral-enabled'
                label='Bet referral enabled'
                name='betReferralEnabled'
                checked={currentTemplate.betReferralEnabled}
                onSave={marketTemplateSettingsState.onSaveTemplate}
            />

            {currentTemplate.eachWaySettings !== null &&  currentTemplate.eachWaySettings !== undefined ?
                <Checkbox
                    dataTest='each-way-enabled'
                    label='Each way enabled'
                    name='eachWayEnabled'
                    checked={currentTemplate.eachWaySettings?.offered ?? false}
                    onSave={marketTemplateSettingsState.onSaveTemplate}
                /> : null
            }


            <Input
                dataTest='each-way-stake-reduction'
                label='Each way stake reduction %'
                name='eachWayStakeReduction'
                value={currentTemplate.eachWayStakeReduction ?? undefined}
                onSave={marketTemplateSettingsState.onSaveTemplate}
                validation={
                    {type: 'range', details: {min: 0, max: 100}}
                }
            />

            <Checkbox
                dataTest='allow-competition-multiples'
                label='Allow competition multiples'
                name='allowCompetitionMultiples'
                checked={currentTemplate.allowCompetitionMultiples}
                onSave={marketTemplateSettingsState.onSaveTemplate}
            />

            <Checkbox
                dataTest='multiple-instances-allowed'
                label='Multiple Instances Allowed'
                name='multipleInstancesAllowed'
                checked={currentTemplate.multipleInstancesAllowed}
                onSave={marketTemplateSettingsState.onSaveTemplate}
            />

            {/*{*/}
            {/*    currentTemplate?.spApplicable || data?.sp ?*/}
            {/*        <Checkbox*/}
            {/*            dataTest='allow-competition-multiples'*/}
            {/*            label='Starting price available'*/}
            {/*            name='sp'*/}
            {/*        /> : null*/}
            {/*}*/}

            {/*{*/}
            {/*    data?.bpApplicable || data?.bp ?*/}
            {/*        <Checkbox*/}
            {/*            dataTest='multiple-instances-allowed'*/}
            {/*            label='Best Odds Guaranteed'*/}
            {/*            name='bp'*/}
            {/*        /> : null*/}
            {/*}*/}

            <h4 data-test='Cash-Out-Header'>Cash out</h4>
            <div className='row'>
                <div className='col-12'>
                    <Checkbox
                        dataTest='cash-out'
                        label='Cash out'
                        name='cashoutAvailable'
                        checked={currentTemplate.cashoutAvailable}
                        onSave={marketTemplateSettingsState.onSaveTemplate}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-4'>
                    <Input
                        dataTest='base-cash-out'
                        label='Base cash out'
                        name='cashoutMarketSettings.baseCashout'
                        onSave={marketTemplateSettingsState.onSaveTemplate}
                        value={currentTemplate.cashoutMarketSettings?.baseCashout ?? undefined}
                        isCache={true}
                        validation={
                            {type: 'range', details: {min: 0, max: 1}}
                        }
                    />
                </div>
                <div className='col-4'>
                    <Input
                        dataTest='cash-out-overround'
                        label='Cash out overround'
                        name='cashoutMarketSettings.cashoutOverround'
                        onSave={marketTemplateSettingsState.onSaveTemplate}
                        value={currentTemplate.cashoutMarketSettings?.cashoutOverround ?? undefined}
                        isCache={true}
                        validation={
                            {type: 'range', details: {min: 0, max: 1}}
                        }
                    />
                </div>
                <div className='col-4'>
                    <Input
                        dataTest='cash-out-offer-easing'
                        label='Cash out offer easing'
                        name='cashoutMarketSettings.cashoutOfferEasing'
                        onSave={marketTemplateSettingsState.onSaveTemplate}
                        value={currentTemplate.cashoutMarketSettings?.cashoutOfferEasing ?? undefined}
                        isCache={true}
                        validation={
                            {type: 'range', details: {min: 0, max: 20}}
                        }
                    />
                </div>

                {/*<h4>Available on (missing API)</h4>*/}
                {/*<div className='row'>*/}
                {/*    <div className='col-6'>*/}
                {/*        <Checkbox*/}
                {/*            dataTest='desktop'*/}
                {/*            label='Desktop'*/}
                {/*            name='availableOn.desktop'*/}
                {/*            checked={false}*/}
                {/*            onSave={onBlur}*/}
                {/*        />*/}
                {/*        <Checkbox*/}
                {/*            dataTest='telebetting'*/}
                {/*            label='Telebetting'*/}
                {/*            name='availableOn.telebetting'*/}
                {/*            checked={false}*/}
                {/*            onSave={onBlur}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*    <div className='col-6'>*/}
                {/*        <Checkbox*/}
                {/*            dataTest='retail'*/}
                {/*            label='Retail'*/}
                {/*            name='availableOn.retail'*/}
                {/*            checked={false}*/}
                {/*            onSave={onBlur}*/}
                {/*        />*/}
                {/*        <Checkbox*/}
                {/*            dataTest='mobile'*/}
                {/*            label='Mobile'*/}
                {/*            name='availableOn.mobile'*/}
                {/*            checked={false}*/}
                {/*            onSave={onBlur}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}

                <h4>Allow in Multiples bet</h4>
                {/*TODO: CheckboxMultiSelect to refactor*/}
                <div data-test='allowed-in-multiples-with'>
                    <CheckboxMultiSelect
                        placeholder=''
                        list={ marketTemplateSettingsState.allowedInMultiplesValues }
                        value={ marketTemplateSettingsState.allowedInMultiplesCurrentValues }
                        name='allowedInMultiplesWith'
                        onCloseMenu={props.marketTemplateSettingsState.onSaveAllowedInMultiples}
                    />
                </div>
            </div>
        </div>
    );
});
